export default __webpack_public_path__ + "static/media/size-chart-error.30656e1b.svg";